import React from "react";
import HeroBanner from "./HeroBanner";
import MainContainer from "./MainContainer";
import WhyChooseUs from "./WhyChooseUs";

const Body = () => {
  return (
    <div>
      {/* <HeroBanner /> */}
      <MainContainer />
      <WhyChooseUs />
    </div>
  );
};

export default Body;
